// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"6":"fe3fafec","155":"c2546e90","318":"d88ed916"}[chunkId] || chunkId) + "-" + {"6":"dad2bf96d76a9253","155":"ae22a6f5edeaec2c","260":"50a095646f757565","318":"c2468381e8b8855e","979":"696a8dcbf0ef4938"}[chunkId] + ".js";
};